import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const ClockIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="8" cy="8" r="7" stroke="#0F172A" strokeWidth="1.33"/>
        <polyline points="8,4 8,8 10,10" stroke="#0F172A" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const DeferredCheckmarkIcon = () => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
    >
        <path
            d="M9 3L4.5 7.5L3 6"
            stroke="#F8FAFC"
            strokeWidth="1.33"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const DeferredClockIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
    >
        <circle cx="8" cy="8" r="7" stroke="#F8FAFC" strokeWidth="1.33"/>
        <polyline points="8,4 8,8 10,10" stroke="#F8FAFC" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

interface DeferButtonProps {
    className?: any;
    isDeferred?: boolean;
    onClick?: any;
    [key: string]: any;
}

export default function DeferButton({
    className,
    isDeferred = false,
    onClick,
    ...props
}: DeferButtonProps) {
    const baseClasses = clsx(
        "inline-flex items-center justify-center transition-colors duration-200",
        "w-10 h-10 rounded-md text-sm font-medium shadow-sm",
        {
            "gap-0.5 bg-teal-600 text-white": isDeferred,
            "gap-2 px-2 py-2 bg-[#F1F5F9] text-gray-900 hover:bg-gray-100": !isDeferred,
        },
        className
    );

    return (
        <button
            className={baseClasses}
            onClick={onClick}
            disabled={isDeferred}
            {...props}
        >
            {isDeferred ? (
                <>
                    <DeferredCheckmarkIcon />
                    <DeferredClockIcon />
                </>
            ) : (
                <ClockIcon />
            )}
        </button>
    );
}

DeferButton.propTypes = {
    className: PropTypes.string,
    isDeferred: PropTypes.bool,
    onClick: PropTypes.func,
};
